var K = Object.defineProperty;
var q = (n) => {
  throw TypeError(n);
};
var Y = (n, e, t) => e in n ? K(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var c = (n, e, t) => Y(n, typeof e != "symbol" ? e + "" : e, t), D = (n, e, t) => e.has(n) || q("Cannot " + t);
var r = (n, e, t) => (D(n, e, "read from private field"), t ? t.call(n) : e.get(n)), i = (n, e, t) => e.has(n) ? q("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), l = (n, e, t, o) => (D(n, e, "write to private field"), o ? o.call(n, t) : e.set(n, t), t), z = (n, e, t) => (D(n, e, "access private method"), t);
function W() {
  return {
    generateUUID: A,
    generateCodeVerifier: G,
    generateCodeChallenge: X
  };
}
function A() {
  return crypto.randomUUID();
}
function G() {
  return A() + A() + A();
}
async function X(n) {
  return Z(await Q(n));
}
function Q(n) {
  const t = new TextEncoder().encode(n);
  return crypto.subtle.digest("SHA-256", t);
}
function Z(n) {
  return btoa(
    [...new Uint8Array(n)].map((e) => String.fromCharCode(e)).join("")
  ).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function H(n) {
  function e(s) {
    const a = n.generateUUID(), h = o(a);
    return sessionStorage.setItem(h, JSON.stringify(s)), a;
  }
  function t(s) {
    const a = o(s), h = sessionStorage.getItem(a);
    if (!h)
      throw new Error("Login state not found");
    return sessionStorage.removeItem(a), JSON.parse(h);
  }
  function o(s) {
    return `@cognite/auth-client/state:${s}`;
  }
  return {
    saveLoginState: e,
    getAndDeleteLoginState: t
  };
}
function ee(n, e) {
  const t = e - n;
  return Math.floor(Math.random() * t + n);
}
function B(n) {
  return new Promise((e) => setTimeout(e, n));
}
var I, v, L;
const f = class f {
  constructor() {
    c(this, "getOpenIdConfiguration", async (e) => {
      var s;
      const t = new URL("/.well-known/openid-configuration", e).href, o = await r(s = f, I).call(s, {
        method: "GET",
        url: t,
        retriable: !0
      });
      return {
        authorizationEndpoint: o.authorization_endpoint,
        tokenEndpoint: o.token_endpoint,
        endSessionEndpoint: o.end_session_endpoint
      };
    });
    c(this, "tokenRequest", async (e) => {
      var s;
      const t = new URLSearchParams();
      t.append("grant_type", "authorization_code"), t.append("redirect_uri", e.redirectUri), t.append("code", e.code), t.append("code_verifier", e.codeVerifier), t.append("client_id", e.clientId);
      const o = await r(s = f, I).call(s, {
        method: "POST",
        url: e.tokenEndpoint,
        retriable: !0,
        body: t
      });
      return V(o);
    });
    c(this, "refreshRequest", async (e) => {
      var s;
      const t = new URLSearchParams();
      t.append("grant_type", "refresh_token"), t.append("refresh_token", e.refreshToken), t.append("client_id", e.clientId);
      const o = await r(s = f, I).call(s, {
        method: "POST",
        url: e.tokenEndpoint,
        retriable: !0,
        body: t
      });
      return V(o);
    });
  }
};
I = new WeakMap(), v = new WeakMap(), L = new WeakMap(), i(f, I, async ({
  method: e,
  url: t,
  retriable: o,
  body: s
}) => {
  var d, $;
  let a, h = !1, u = 0;
  do
    a = await fetch(t, {
      method: e,
      body: s
    }), !a.ok && o ? (h = r(d = f, v).call(d, a.status, u), h && (await B(r($ = f, L).call($, u)), u++)) : h = !1;
  while (h);
  if (!a.ok)
    throw new Error(
      `Request to ${t} failed with status code ${a.status}`
    );
  return await a.json();
}), i(f, v, (e, t) => t >= 3 ? !1 : e === 503 || e === 429), // Calculate the delay for the next retry attempt
// using exponential backoff with jitter
i(f, L, (e) => ee(
  0,
  250 + (2 ** e - 1) / 2 * 1e3
));
let x = f;
function V(n) {
  return {
    accessToken: n.access_token,
    idToken: n.id_token,
    refreshToken: n.refresh_token
  };
}
function j(n, e) {
  return [new URL(n).href, e].map(encodeURIComponent).join(":");
}
function te(n) {
  try {
    const [e, t] = n.split(".").slice(0, 2).map((o) => JSON.parse(re(o)));
    return t;
  } catch {
    throw new Error(`Invalid JWT: ${n}`);
  }
}
function ne(n) {
  const e = atob(n);
  return Uint8Array.from(e, (t) => t.codePointAt(0));
}
function re(n) {
  const e = n.replace(/-/g, "+").replace(/_/g, "/"), t = n.length % 4 === 0 ? "" : "=".repeat(4 - n.length % 4), o = e + t, s = ne(o);
  return new TextDecoder().decode(s);
}
var w;
class oe {
  constructor(e, t) {
    i(this, w);
    c(this, "persistTokens", (e) => {
      const t = te(
        e.idToken
      ), o = t.exp - t.iat, s = Math.floor(o * 0.1), a = {
        ...e,
        idTokenPayload: t,
        shouldRefreshAfterInUnixTsMs: (t.exp - s) * 1e3
      };
      return localStorage.setItem(r(this, w), JSON.stringify(a)), a;
    });
    c(this, "readTokens", () => {
      const e = localStorage.getItem(r(this, w));
      return e ? JSON.parse(e) : null;
    });
    c(this, "deleteTokens", () => {
      localStorage.removeItem(r(this, w));
    });
    l(this, w, `@cognite/auth-client/tokens:${j(
      e,
      t
    )}`);
  }
}
w = new WeakMap();
class J extends Error {
  constructor(e, t) {
    super(`Authentication error: ${e} - ${t}`), this.name = "AuthenticationError", Object.setPrototypeOf(this, J.prototype);
  }
}
var y, S, p, R, k, _, P, O;
class se {
  constructor(e) {
    i(this, y);
    i(this, S);
    i(this, p);
    i(this, R);
    i(this, k);
    i(this, _);
    i(this, P);
    c(this, "signinRedirect", async ({
      redirectUri: e,
      state: t,
      organization: o
    }) => {
      const s = await r(this, p).getOpenIdConfiguration(
        r(this, y)
      ), a = r(this, R).generateCodeVerifier(), h = await r(this, R).generateCodeChallenge(a), u = r(this, _).saveLoginState({
        codeVerifier: a,
        redirectUri: e,
        data: t || null
      });
      r(this, k).deleteTokens();
      const d = new URL(s.authorizationEndpoint);
      return d.searchParams.append("client_id", r(this, S)), d.searchParams.append("redirect_uri", e), d.searchParams.append("response_type", "code"), d.searchParams.append("scope", "openid offline_access email profile"), d.searchParams.append("state", u), d.searchParams.append("code_challenge", h), d.searchParams.append("code_challenge_method", "S256"), o && d.searchParams.append("organization_hint", o), window.location.href = d.href, new Promise(() => {
      });
    });
    c(this, "handleSigninRedirectCallback", async () => {
      const e = await r(this, p).getOpenIdConfiguration(
        r(this, y)
      ), t = new URL(window.location.href), o = t.searchParams.get("error"), s = t.searchParams.get("error_description"), a = t.searchParams.get("code"), h = t.searchParams.get("state");
      if (o && h)
        throw new J(o, s ?? "");
      if (!a || !h)
        throw new Error(
          "Missing code and/or state query parameters in the URL. Are you sure you are being redirected from the authorization server?"
        );
      const u = r(this, _).getAndDeleteLoginState(h), d = await r(this, p).tokenRequest({
        tokenEndpoint: e.tokenEndpoint,
        code: a,
        clientId: r(this, S),
        codeVerifier: u.codeVerifier,
        redirectUri: u.redirectUri
      });
      return r(this, k).persistTokens({
        accessToken: d.accessToken,
        idToken: d.idToken,
        refreshToken: d.refreshToken
      }), t.searchParams.delete("code"), t.searchParams.delete("state"), t.searchParams.delete("scope"), window.history.replaceState({}, document.title, t), u.data;
    });
    c(this, "signoutRedirect", async ({
      redirectUri: e
    }) => {
      const t = r(this, k).readTokens();
      if (!t)
        return window.location.href = e, new Promise(() => {
        });
      const o = await r(this, p).getOpenIdConfiguration(
        r(this, y)
      );
      r(this, k).deleteTokens();
      const s = new URL(o.endSessionEndpoint);
      return s.searchParams.append("id_token_hint", t.idToken), s.searchParams.append("post_logout_redirect_uri", e), window.location.href = s.href, new Promise(() => {
      });
    });
    c(this, "getTokens", async () => {
      const e = await r(this, O).call(this);
      return e ? {
        accessToken: e.accessToken,
        idToken: e.idToken,
        refreshToken: e.refreshToken,
        idTokenPayload: e.idTokenPayload
      } : null;
    });
    /**
     * Check if the user is authenticated.
     *
     * It will start by checking local storage for tokens.
     * If tokens are found, it will check if they have expired
     * based on the `exp` claim in the ID token.
     * If they are expired, then we will perform a token refresh.
     *
     * Will return false if any steps fail, otherwise true.
     */
    i(this, O, async () => {
      const e = r(this, k).readTokens();
      if (!e)
        return null;
      if (e.shouldRefreshAfterInUnixTsMs > Date.now())
        return e;
      try {
        return await r(this, P).tryRefreshTokens();
      } catch {
        return null;
      }
    });
    l(this, y, e.authority), l(this, S, e.clientId), l(this, p, e.httpClient), l(this, R, e.cryptoUtils), l(this, k, e.tokenStorage), l(this, _, e.stateStorage), l(this, P, e.tokenRefresher);
  }
}
y = new WeakMap(), S = new WeakMap(), p = new WeakMap(), R = new WeakMap(), k = new WeakMap(), _ = new WeakMap(), P = new WeakMap(), O = new WeakMap();
var b, m, E, U, T, N, F, C, M;
class ae {
  constructor(e) {
    i(this, N);
    i(this, b);
    i(this, m);
    i(this, E);
    i(this, U);
    i(this, T, null);
    c(this, "tryRefreshTokens", async () => await r(this, C).call(this, !1));
    c(this, "stopBackgroundJob", () => {
      r(this, T) && (clearInterval(r(this, T)), l(this, T, null));
    });
    i(this, C, async (e, t) => {
      const o = {
        ifAvailable: e,
        mode: "exclusive",
        signal: t
      };
      return await window.navigator.locks.request(
        r(this, E),
        o,
        r(this, M)
      );
    });
    i(this, M, async (e) => {
      if (!e)
        return null;
      const t = r(this, m).readTokens();
      if (!t)
        return null;
      if (t.shouldRefreshAfterInUnixTsMs > Date.now())
        return t;
      try {
        const o = await r(this, U).call(this, t.refreshToken), s = r(this, m).persistTokens({
          accessToken: o.accessToken,
          idToken: o.idToken,
          refreshToken: o.refreshToken
        });
        return await B(50), s;
      } catch (o) {
        return console.warn("Failed to refresh tokens: ", o), r(this, m).deleteTokens(), null;
      }
    });
    l(this, b, e.checkForRefreshIntervalInMs), l(this, m, e.tokenStorage), l(this, E, e.globalLockName), l(this, U, e.refresh), z(this, N, F).call(this);
  }
}
b = new WeakMap(), m = new WeakMap(), E = new WeakMap(), U = new WeakMap(), T = new WeakMap(), N = new WeakSet(), F = function() {
  if (r(this, T))
    throw new Error("Background job already running");
  l(this, T, window.setInterval(
    () => r(this, C).call(this, !0),
    r(this, b)
  ));
}, C = new WeakMap(), M = new WeakMap();
function ie(n) {
  const { authority: e, clientId: t } = n, o = W(), s = new oe(e, t), a = new x(), h = new ae({
    checkForRefreshIntervalInMs: 15e3,
    tokenStorage: s,
    globalLockName: `@cognite/auth-client:refresh-tokens:${j(
      e,
      t
    )}`,
    refresh: async (u) => {
      const d = await a.getOpenIdConfiguration(e);
      return a.refreshRequest({
        tokenEndpoint: d.tokenEndpoint,
        clientId: t,
        refreshToken: u
      });
    }
  });
  return new se({
    authority: e,
    clientId: t,
    httpClient: a,
    tokenStorage: s,
    tokenRefresher: h,
    cryptoUtils: o,
    stateStorage: H(o)
  });
}
var g;
class de {
  /**
   *
   * @param options - The options for the AuthClient.
   */
  constructor(e) {
    i(this, g);
    /**
     * Call this method to sign-in the user. After a successful login, the user will be redirected to the provided redirectUri.
     * To complete the sign-in flow, call {@link AuthClient.handleSigninRedirectCallback} after the user is redirected back to the redirectUri.
     *
     * @param options - sign-in options.
     * @returns Returns a never resolving promise as the browser should wait for the redirect to take place.
     *
     * @example
     * ```js
     * await authClient.signinRedirect({
     *   redirectUri: 'https://localhost/redirect-uri',
     *   state: { foo: 'bar'},
     *   organization: 'cog-demo',
     * });
     * ```
     *
     */
    c(this, "signinRedirect", async (e) => {
      const { redirectUri: t, state: o, organization: s } = e;
      await r(this, g).signinRedirect({
        redirectUri: t,
        state: o,
        organization: s
      });
    });
    /**
     * This function completes the sign-in flow. This function should only be called after the user ends up on the redirect URI after calling {@link AuthClient.signinRedirect}.
     *
     * @remarks
     * The function will remove the query parameters `state`, `code` and `scope` from the URL.
     *
     * @returns Returns the state object that was passed in the {@link AuthClient.signinRedirect} method. `null` if no state was provided.
     * @throws {@link AuthenticationError} on authentication errors (OAuth errors).
     * @throw Error if the URL is missing the `code` and/or `state` query parameters. Meaning we called this function outside of the sign-in flow.
     *
     * @example
     * ```js
     * const state = await authClient.handleSigninRedirectCallback();
     * ```
     */
    c(this, "handleSigninRedirectCallback", async () => r(this, g).handleSigninRedirectCallback());
    /**
     *
     * @param options - sign-out options.
     * @returns Returns a never resolving promise as the browser should wait for the redirect to take place.
     *
     * @example
     * ```js
     * await authClient.signoutRedirect({ redirectUri: 'https://localhost/signout-redirect-uri' });
     * ```
     */
    c(this, "signoutRedirect", async (e) => {
      const { redirectUri: t } = e;
      return r(this, g).signoutRedirect({
        redirectUri: t
      });
    });
    /**
     * Gets the access token from the current session.
     * @remarks NB! You should NEVER parse this token.
     * @returns The access token if the user is signed in, otherwise `null`.
     */
    c(this, "getAccessToken", async () => {
      const e = await r(this, g).getTokens();
      return (e == null ? void 0 : e.accessToken) ?? null;
    });
    /**
     * Gets the ID token from the current session.
     * @returns The ID token if the user is signed in, otherwise `null`.
     */
    c(this, "getIdToken", async () => {
      const e = await r(this, g).getTokens();
      return (e == null ? void 0 : e.idToken) ?? null;
    });
    /**
     * Gets user profile information from the current session.
     * @returns The user profile if the user is signed in, otherwise `null`.
     */
    c(this, "getUser", async () => {
      const e = await r(this, g).getTokens();
      if (!e)
        return null;
      const { idTokenPayload: t } = e;
      return {
        // Required fields, we guarantee returning this.
        id: t.sub,
        picture: t.picture,
        org: t.org,
        // Optional fields, since user profiles can be disabled, we can't guarantee to have these.
        email: t.email,
        name: t.name,
        givenName: t.given_name,
        familyName: t.family_name
      };
    });
    const { authority: t = "https://auth.cognite.com", clientId: o } = e;
    l(this, g, ie({ authority: t, clientId: o }));
  }
}
g = new WeakMap();
export {
  de as AuthClient,
  J as AuthenticationError
};
